import React from 'react';

import { BlockquoteBlockData } from 'api/cms';
import { Box } from 'components/Box';
import { Body, BodyLarge, RichText } from 'components/Text';

type Props = {
  data: BlockquoteBlockData;
};

export function AmpBlockquoteBlock({ data: { quote, cite } }: Props) {
  return (
    <RichText>
      <Box component="blockquote">
        <BodyLarge
          dangerouslySetInnerHTML={{
            __html: quote,
          }}
        />
        {cite && (
          <Box mt="18px">
            <Body>{cite}</Body>
          </Box>
        )}
      </Box>
    </RichText>
  );
}
